export const environment = {
  production: true,
  apiUrl: `${document.location.protocol}//${document.location.host}/pairing-product/api`,
  auth: {
    domain: 'dacoval-prod.eu.auth0.com',
    clientId: 'xmnk5oNHsY81zXJQExQMwRdXnlv4mJVv',
    clientSecret:
      'MnVrEDG4oIKyaK7rQq8KBBOp5QuQErlmu7w_qsMgzJ1SAk1Bxf4YxPxv_pcdjS31',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://pairing-api.azurewebsites.net',
      cookieDomain: '.azurewebsites.net',
      useCookiesForTransactions: true,
      SameSite: 'None',
    },
  }
};

